
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactGA from 'react-ga';
import './App.css';

ReactGA.initialize('UA-214166489-1');

function App() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [countdown, setCountdown] = useState(10);
  const [isTimerPaused, setIsTimerPaused] = useState(false);
  const redirectTimeoutRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const currentEpisodeRef = useRef({ id: null, title: "" });

  const clearTimers = useCallback(() => {
    if (redirectTimeoutRef.current) {
      clearTimeout(redirectTimeoutRef.current);
      redirectTimeoutRef.current = null;
    }
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }
  }, []);

  const startEpisodeTimer = useCallback((episodeId, episodeTitle, seconds = 10) => {
    clearTimers();
    currentEpisodeRef.current = { id: episodeId, title: episodeTitle };
    setCountdown(seconds);
    setIsTimerPaused(false);

    countdownIntervalRef.current = setInterval(() => {
      setCountdown((prev) => (prev > 1 ? prev - 1 : 1));
    }, 1000);

    redirectTimeoutRef.current = setTimeout(() => {
      ReactGA.event({ category: 'Watch', action: 'Seinfeld', label: episodeTitle });
      window.location.href = "https://www.netflix.com/watch/" + episodeId;
    }, seconds * 1000);
  }, [clearTimers]);

  const pauseEpisodeTimer = useCallback(() => {
    if (!redirectTimeoutRef.current || isTimerPaused) {
      return;
    }

    clearTimers();
    setIsTimerPaused(true);
  }, [clearTimers, isTimerPaused]);

  const resumeEpisodeTimer = useCallback(() => {
    if (!isTimerPaused) {
      return;
    }

    const remainingSeconds = Math.max(countdown, 1);
    const { id, title: episodeTitle } = currentEpisodeRef.current;
    if (!id) {
      return;
    }

    startEpisodeTimer(id, episodeTitle, remainingSeconds);
  }, [countdown, isTimerPaused, startEpisodeTimer]);

  const pickRandomEpisode = useCallback(async () => {
    var season = Math.floor(Math.random() * 9 + 1);
    console.log('season is ' + season);
    const response = await fetch('data/season' + season + '.txt');
    const json = await response.json();

    delete json.jsonGraph.videos['70153373'];
    var episodes = Object.keys(json.jsonGraph.videos);
    var ran_key = episodes[Math.floor(Math.random() * episodes.length)];
    const episodeTitle = json.jsonGraph.videos[ran_key].title.value;
    const episodeDescription = json.jsonGraph.videos[ran_key].synopsis.value;

    setTitle(episodeTitle);
    setDescription(episodeDescription);
    startEpisodeTimer(ran_key, episodeTitle);
  }, [startEpisodeTimer]);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
    pickRandomEpisode();

    return () => {
      clearTimers();
    };
  }, [clearTimers, pickRandomEpisode]);

  return (
    <div className="App">
      <header className="App-header">
        <img className="hero-logo" src={process.env.PUBLIC_URL + "randomjerry.png"} alt="logo" />
        <div className="episode-panel">
          <p className="episode-title"><b>{title}</b></p>
          <button className="shuffle-button" onClick={pickRandomEpisode} type="button">
            <svg
              className="shuffle-icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M17 3h4v4" />
              <path d="M3 7h5l4 5 4 5h5" />
              <path d="M21 3l-7 7" />
              <path d="M21 17v4h-4" />
              <path d="M21 21l-7-7" />
              <path d="M3 17h5" />
            </svg>
            Shuffle
          </button>
          <p className="episode-description">{description}</p>
        </div>
        <p className='saving'>
          Starting Seinfeld episode on Netflix in {countdown}...
        </p>
        <div className="partners-module">
          <p className="partners-title">Sponsors (not that there's anything wrong with that)</p>
          <div className="partners-grid" onMouseEnter={pauseEpisodeTimer} onMouseLeave={resumeEpisodeTimer}>
            <a className="partner-card" href="https://www.colorquiz.com" target="_blank" rel="noreferrer">
              <img
                className="partner-image"
                src={process.env.PUBLIC_URL + "/logo_color_jpg.jpg"}
                alt="ColorQuiz.com"
              />
              <span className="partner-caption">Find your color personality</span>
            </a>
            <a className="partner-card" href="https://casesarcade.com" target="_blank" rel="noreferrer">
              <img
                className="partner-image"
                src={process.env.PUBLIC_URL + "/arcade-logo.png"}
                alt="Case's arcade"
              />
              <span className="partner-caption">Free online games</span>
            </a>
            <a className="partner-card" href="https://www.myleague.com" target="_blank" rel="noreferrer">
              <img
                className="partner-image"
                src={process.env.PUBLIC_URL + "/myleague.png"}
                alt="MyLeague.com"
              />
              <span className="partner-caption">Gaming leagues & tournaments</span>
            </a>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
